import { useTranslation } from "react-i18next";

import _ from "lodash";
import styled from "styled-components";

import { Frame, Row, RowWrapper } from "components/ui-kit/styled-templates";

import { TPagination } from "hooks/usePagination";

const PaginationControl = ({ pagination }: { pagination: TPagination }) => {
    const { t } = useTranslation();

    const { perPage, currentPage, totalCount, pagesCount, handlePageNavigation, handleNextPage, handlePrevPage } = pagination;

    return (
        <Wrapper>
            <Row extra={`gap: 0 4px; width: ${totalCount > 3 ? `200px` : `auto`}; justify-content: space-between;`}>
                <Arrow onClick={handlePrevPage} direction="left" />
                {_.range(0, pagesCount === Infinity ? 0 : pagesCount)
                    .map((i, j, self) => (i === 0 || i === self[self.length - 1] || Math.abs(i - currentPage) <= 1 ? i : -1))
                    .filter((i, j, self) => j < 1 || self[j - 1] !== i)
                    .map((i) =>
                        i === -1 ? (
                            `...`
                        ) : (
                            <strong key={i} onClick={() => handlePageNavigation(i)} className={i === currentPage ? `selected` : `unselected`}>
                                {i + 1}
                            </strong>
                        ),
                    )}
                <Arrow onClick={handleNextPage} direction="right" />
            </Row>
            <strong>
                {t("rhcj78008lq")} {perPage * currentPage + 1}–{Math.min(perPage * (currentPage + 1), totalCount)} {t("aay3qt1elrj")} {totalCount}
            </strong>
        </Wrapper>
    );
};

const Arrow = styled(Frame)<{ direction: `left` | `right` }>`
    width: 16px;
    height: 16px;
    background: url("${require(`assets/icons/select-arrow.svg`).default}") no-repeat center center / contain;
    transform: rotate(${({ direction }) => (direction === `left` ? 90 : -90)}deg);
    ${({ direction }) => (direction === `left` ? `margin-right` : `margin-left`)}: 8px;
    cursor: pointer;
`;

const Wrapper = styled(RowWrapper)`
    padding: 20px 24px;
    box-sizing: border-box;
    border: 1px solid ${({ theme }) => theme.halfblue};
    margin: 10px 0;
    border-radius: 4px;

    .selected {
        cursor: pointer;
        color: ${({ theme }) => theme.text.primary};
    }
    .unselected {
        cursor: pointer;
        color: ${({ theme }) => theme.text.secondary};
    }
`;

export default PaginationControl;
